import { Routes } from '@angular/router';
import { InTheNewsContainerComponent } from './in-the-news-container/in-the-news-container.component';
import { InTheNewsCoverComponent } from './in-the-news-cover/in-the-news-cover.component';
import { GoodfirmsPrComponent } from './goodfirms-pr/goodfirms-pr.component';
import { NewsSixthAnniversaryComponent } from './news-sixth-anniversary/news-sixth-anniversary.component';
import { InfluentialBusinessComponent } from './influential-business/influential-business.component';
import { PioneeringAiComponent } from './pioneering-ai/pioneering-ai.component';
import { AboutKalpitaComponent } from './about-kalpita/about-kalpita.component';
import { AboutCeoComponent } from './about-ceo/about-ceo.component';
import { KalpitaTechnologiesGreatPlaceToWorkCertifiedComponent } from './kalpita-technologies-great-place-to-work-certified/kalpita-technologies-great-place-to-work-certified.component';

export const inthenews_routes:Routes=[
    {path:"",component:InTheNewsContainerComponent,children:[
        {path:'inthenews',component:InTheNewsCoverComponent},
        {path:'goodfirms',component:GoodfirmsPrComponent},
        {path:'kalpita-sixth-anniversary',component:NewsSixthAnniversaryComponent},
        {path:'influential-business',component:InfluentialBusinessComponent},
        {path:'pioneering-ai',component:PioneeringAiComponent},
        {path:'about-kalpita',component:AboutKalpitaComponent},
        {path:'about-ceo',component:AboutCeoComponent},
        {path:'kalpita-technologies-great-place-to-work-certified',component:KalpitaTechnologiesGreatPlaceToWorkCertifiedComponent}
    ]}
]